export const checkInAppBrowser = (): boolean => {
  const userAgent = window.navigator.userAgent

  // Common social media in-app browsers
  const inAppBrowserPatterns = [
    /FBAN|FBAV/i, // Facebook
    /WhatsApp/i, // WhatsApp,
    /Instagram/i, // Instagram
    /Twitter|XAndroid|X for iPhone/i, // Twitter (X)
    /TikTok/i, // TikTok
    /LinkedIn/i, // LinkedIn
    /Snapchat/i, // Snapchat
    /Reddit/i, // Reddit
    /\bGSA\b|Google Search App/i, // Google Search App (Android & iOS)
    /BingSapphire/i, // Bing Search
    // Yahoo Search + Brave work within app browsers
  ]

  // Check all patterns
  const checkBrowser = inAppBrowserPatterns.some((pattern) => pattern.test(userAgent))

  return checkBrowser
}
